import { useEffect, useMemo, useState } from 'react'
import type { Activiteit } from '../../../gedeeld/types'
import { api } from '../../lib/api'
import { datumTijd, geleden } from '../../lib/opmaak'
import { navigeer } from '../../lib/router'
import { openTaak } from '../../lib/staat'
import { Avatar, Foutvlak, Laden } from '../ui'

/* ===========================================================================
 *  Wat er in dit project gebeurde, per dag
 *
 *  Uit het logboek in MongoDB. Dat logboek is er sinds Projects er is; wat
 *  er daarvoor in Werk gebeurde staat er niet in, en dat zegt het scherm.
 * =========================================================================== */

export default function ProjectActiviteit({ projectId }: { projectId: string }) {
  const [regels, setRegels] = useState<Activiteit[] | null>(null)
  const [bereikbaar, setBereikbaar] = useState(true)
  const [fout, setFout] = useState<string | null>(null)

  useEffect(() => {
    api.activiteit({ projectId, limiet: 200 })
      .then((x) => { setRegels(x.activiteit); setBereikbaar(x.bereikbaar) })
      .catch((e) => setFout(e instanceof Error ? e.message : String(e)))
  }, [projectId])

  const perDag = useMemo(() => {
    const m = new Map<string, Activiteit[]>()
    for (const r of regels ?? []) {
      const d = new Date(r.at).toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' })
      m.set(d, [...(m.get(d) ?? []), r])
    }
    return [...m.entries()]
  }, [regels])

  if (fout) return <Foutvlak fout={fout} />
  if (!regels) return <Laden />
  if (!bereikbaar) return <p className="stil">Het logboek staat in MongoDB en is nu niet bereikbaar. De taken zelf zijn in orde.</p>
  if (!regels.length) return <p className="stil">Nog niets vastgelegd. Het logboek houdt bij wat er vanaf nu in Projects gebeurt.</p>

  return (
    <div className="activiteit">
      {perDag.map(([dag, lijst]) => (
        <section key={dag} className="groep">
          <h2 className="groep-kop">{dag}</h2>
          <div className="geschiedenis">
            {lijst.map((r) => (
              <div key={r.id} className="geschiedenis-regel">
                <Avatar naam={r.wieNaam} id={r.wie} grootte={22} />
                <span>
                  <strong>{r.wieNaam}</strong>{' '}
                  {r.taakId ? <button type="button" className="link-knop" onClick={() => openTaak(r.taakId!)}>{r.tekst}</button>
                    : r.bordId ? <button type="button" className="link-knop" onClick={() => navigeer(`/wb/${r.bordId}`)}>{r.tekst}</button>
                      : r.tekst}
                </span>
                <span className="vul" />
                <span className="stil" title={datumTijd(r.at)}>{geleden(r.at)}</span>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  )
}
